import { foundations as commonFoundations } from '../../commons/foundations';
import { colors } from './colors';

const foundations = {
  ...commonFoundations,
  colors,
};

export default foundations;
